import type { ReactNode } from 'react'
import { TitleHeader } from './Header/TitleHeader'

interface LayoutProps {
  readonly children: ReactNode
}

export function Layout({ children }: LayoutProps) {
  return (
    <div>
      <TitleHeader />
      <div className='pb-28 md:pb-0'>{children}</div>
    </div>
  )
}
